import { IOnInit } from "angular";
import { MachineConfiguration } from "../../models/machineConfiguration";
import { Machine } from "../../models/machine";
import { File, Hyperlink } from "../../../../records/server/crud";

export class MachineConfigurationDetailViewComponentController
  implements IOnInit
{
  static $inject = [];

  machine: Machine | undefined;
  machineConfiguration: MachineConfiguration | undefined;

  allFiles!: File[];
  allHyperlinks!: Hyperlink[];

  $onInit(): void {
    const machineConfigurationType = <any>(
      this.machineConfiguration?.MachineConfigurationType
    );
    const machineConfigurationTypeFiles =
      <File[]>machineConfigurationType?.Files ?? [];

    const machineConfigurationFiles =
      <File[]>this.machineConfiguration?.Files ?? [];

    this.allFiles = [
      ...machineConfigurationTypeFiles,
      ...machineConfigurationFiles,
    ];

    const machineConfigurationTypeHyperlinks =
      <Hyperlink[]>machineConfigurationType?.Hyperlinks ?? [];

    const machineConfigurationHyperlinks =
      <Hyperlink[]>this.machineConfiguration?.Hyperlinks ?? [];

    this.allHyperlinks = [
      ...machineConfigurationTypeHyperlinks,
      ...machineConfigurationHyperlinks,
    ];
  }
}
